module.exports = __webpack_public_path__ + "static/015-cfcc528e1521dd1b62a9d53d0c2aa4f3.jpg";